import { AxiosInstance } from 'axios';
import { Site, SLD } from '@patsnap-utils/biz';
import type {Context} from "./CaseTime/context";

export class Service {
    _axios: AxiosInstance | undefined
    _passportUrl: string = new Site({ sld: SLD.PASSPORT }).href
    _accountUrl: string = new Site({ sld: SLD.ACCOUNT }).href
    _accountServiceUrl: string = new Site({ sld: SLD.ACCOUNT_SERVICE }).href;

    static CustomEventName = 'header:CaseTime'

    context: Context | undefined

    setContext(context: Context) {
        this.context = context;
    }

    set axios(value) {
        this._axios = value
    }

    get axios() {
        if (!this._axios) {
            throw new Error('axios is required')
        }
        return this._axios
    }

    set passportUrl(value) {
        this._passportUrl = value
    }

    get passportUrl() {
        if (!this._passportUrl) {
            throw new Error('passport url is required')
        }
        return this._passportUrl
    }

    set accountUrl(value) {
        this._accountUrl = value
    }

    get accountUrl() {
        if (!this._accountUrl) {
            throw new Error('account url is required')
        }
        return this._accountUrl
    }

    set accountServiceUrl(value) {
        this._accountServiceUrl = value
    }

    get accountServiceUrl() {
        if (!this._accountServiceUrl) {
            throw new Error('account service url is required')
        }
        return this._accountServiceUrl
    }
}
